import { Datepicker, MbscCalendarEvent } from "@mobiscroll/react";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead, { DataListType } from "../../components/AsyncTypeahead";
import { ToastConfig } from "../../components/Toaster";
import {
  UpdateInterventionRequest,
} from "pgi-experience-client";
import { WorkflowState, WorkflowStateWithNextState } from "common-util-experience-client";
import { createPgiApi } from "../../api-helpers/PgiApiHelper";
import { createWorkflowApi } from "../../api-helpers/CommonUtilsApiHelper";
import { createUsersApi } from "../../api-helpers/UserApiHelper";
import { WorkflowConstants } from "../../helper/WorkflowConstants";
import { formatDateTask } from "../../helper/dateFormatter";
import { PatientIntervention } from "grid-experience-client";


export interface interventionProps {
  selectedIntervention?: PatientIntervention;
  onUpdateIntervention: (toasterConfig: ToastConfig) => Promise<void>;
  setOffCanvasShow: React.Dispatch<React.SetStateAction<boolean>>;
  loadPgis: () => void;
}
export const EditIntervention = (props: interventionProps) => {

  const pgiApi = createPgiApi();
  const workflow = createWorkflowApi();
  const coach = createUsersApi();


  const [validated, setValidated] = useState(false);
  const [openPicker, setOpenPicker] = useState<boolean>(false);

  const initialInterventionForm: UpdateInterventionRequest = {
    dueDate: props.selectedIntervention?.dueDate || new Date(),
    status: props.selectedIntervention?.interventionDesignerStateId || '',
    assignee: props.selectedIntervention?.assigneeId || '',
    interventionComment: "",
  };

  const [interventionForm, setInterventionForm] = useState<UpdateInterventionRequest>(initialInterventionForm);
  const [workflowStatus, setWorkflowStatus] = useState<WorkflowState[]>();
  const getWorkflowStatus = async () => {
    try {
    const workflowApi = createWorkflowApi();
    const response = await workflowApi.workflowControllerGetStatesForWorkflow(WorkflowConstants.interventions);
    setWorkflowStatus((await response).data);
      console.log("Workflow Status : " + workflowStatus);
    } catch (error) {
      console.error("Error fetching workflow status : " + error);
    }
  };

  useEffect(() => {
    setInterventionForm({
      dueDate: props.selectedIntervention?.dueDate || new Date(),
      status: props.selectedIntervention?.interventionDesignerStateId || '',
      assignee: props.selectedIntervention?.assigneeId || '',
      interventionComment: "",
    })
    getWorkflowStatus();
  }, []);

  const [coachList, setCoachList] = useState<DataListType[]>([]);
  const [validCoach, setValidCoach] = useState<boolean>(true);

  const selectCoach = (selected: any) => {
    setInterventionForm({
      ...interventionForm,
      assignee: selected && selected.key,
    });
  };

  const handleUpdateIntervention = (
    e:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setInterventionForm({
      ...interventionForm,
      [e.target.name] : e.target.value,
    });
  };

  const loadCoachesList = async (query: string) => {
    if (interventionForm.assignee) {
      setInterventionForm({ ...interventionForm, assignee: "" });
    }
    if (!query) {
      setCoachList([]);
      return;
    }
    try {
      const response = await coach.usersControllerSearchUsers(undefined, query);
      const result = response.data.map((result: any) => ({
        key: result.key,
        value: result.value,
      }));
      setCoachList(result);
    } catch (error) {
      console.log(error);
    }
  };

  const dateRangeChangeHandlar = (event: MbscCalendarEvent) => {
    const { name, value } = event;
    if(!value || value < interventionForm.dueDate) return; 
    const selectedDate = new Date(value);
    const utcDate = new Date(
      Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      )
    );
    setInterventionForm({...interventionForm, 
      dueDate: utcDate});
  };
  const handleDiscard = () => {
    props.setOffCanvasShow(false);
  };


  const updateIntervention = async () =>{
      if(props.selectedIntervention!.patientInterventionId) {
        const updatedPayload = {
          ...interventionForm
        };
        await pgiApi.pgiControllerUpdateIntervention(updatedPayload, props.selectedIntervention!.patientInterventionId);
      }
  }

  const updateInterventionHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setValidated(true);
    const form = event.currentTarget;
    console.log('update interventionForm : ', interventionForm)
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if(!interventionForm.dueDate) return;

    try {
      await updateIntervention();
      const toasterConfig = {
        type: "success",
        title: "Intervention updated successfully!",
        icon: "check_circle_outline",
      };
      props.onUpdateIntervention(toasterConfig as ToastConfig);
      props.loadPgis();
      handleDiscard();
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message?.message;
      const toasterConfig = {
        type: "danger",
        title: errorMessage,
        icon: "error_outline",
      };
      props.onUpdateIntervention(toasterConfig as ToastConfig);
    }
  };
  return (
    <Form
      className="d-flex flex-column h-100"
      noValidate
      validated={validated}
      onSubmit={(e) => updateInterventionHandler(e)}
    >
      <div className="flex-fill">
        <div className="row g-2 mb-3">
          <div className="col-12">
            <label htmlFor="task" className="form-label fs-12 fw-semibold mb-1">
              Intervention
            </label>
            <input
              type="text"
              name="Intervention"
              className="form-control form-control-sm"
              id="Intervention"
              value={
                props.selectedIntervention &&
                props.selectedIntervention.intervention?.intervention
              }
              disabled
            />
          </div>
          <div className="col-6">
            <label
              htmlFor="targetDate"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Due Date
            </label>
            <div className="mobiscroll">
              <div className="mobiscroll__calendar">
                <Datepicker
                  id="dueDate"
                  controls={["calendar"]}
                  calendarType="month"
                  theme="windows"
                  themeVariant="light"
                  placeholder="MM/DD/YYYY"
                  display="bubble"
                  touchUi={true}
                  buttons={[]}
                  defaultValue={props.selectedIntervention?.dueDate}
                  value = {formatDateTask(interventionForm.dueDate)}
                  showOnClick={false}
                  isOpen={openPicker}
                  onClose={() => {setOpenPicker(false)}}
                  min={ props.selectedIntervention?.dueDate && new Date(props.selectedIntervention?.dueDate) < new Date()
                    ? formatDateTask(props.selectedIntervention?.dueDate)
                    : new Date() }
                  onChange={dateRangeChangeHandlar}
                  required
                />
              </div>
              <div onClick={() => setOpenPicker(!openPicker)} className="mobiscroll__calendar-icon">
                  <span className="material-symbols-outlined fs-18" >
                    calendar_month
                  </span>
              </div>
            </div>
          </div>
          <div className="col-6">
            <label
              htmlFor="status"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Status
            </label>
            <select
              className="form-select form-select-sm "
              name="status"
              required
              value={interventionForm.status}
              onChange={(e) => handleUpdateIntervention(e)}
            >
              {workflowStatus?.map((status) => (
                <option key={status.stateId} value={status.stateId}>
                  {status.stateName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="mb-3">
          <label
            htmlFor="assignTo"
            className="form-label fs-12 fw-semibold mb-1"
          >
            Assignee
          </label>
          <AsyncTypeahead
            name="assignee"
            options={coachList}
            onSelect={selectCoach}
            callback={loadCoachesList}
            placeholder={"Search Assignee"}
            defaultValue={props.selectedIntervention?.assigneeUserId}
            required={true}
            isValid={validCoach}
          ></AsyncTypeahead>
        </div>
        <div className="mb-3">
          <label htmlFor="Notes" className="form-label fs-12 fw-semibold mb-1">
            Comments
          </label>
          <textarea
            name="interventionComment"
            className="form-control form-control-sm"
            id="Notes"
            placeholder="Type comments here..."
            rows={3}
            onChange={(e) => handleUpdateIntervention(e)}
          ></textarea>
        </div>
      </div>

      <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
        <div>
          <button
            className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13"
            type="reset"
            onClick={handleDiscard}
          >
            Discard
          </button>
        </div>
        <div>
          <button
            className="btn btn-sm btn-secondary rounded-pill px-5 fs-13"
            type="submit"
          >
            Update
          </button>
        </div>
      </div>
    </Form>
  );
};
